import { AsyncComponent } from '@frontend/elements';
import { Route } from 'react-router-dom';

import { SettingCreate } from './setting-create/setting-create.component';

export function SettingRoutes() {
    return (
        <Route path='settings'>
            <Route path=':entity_type'>
                <Route path=':entity_id'>
                    {/* list as index */}
                    <Route
                        path='update'
                        element={
                            <AsyncComponent>
                                <SettingCreate />
                            </AsyncComponent>
                        }
                    />
                </Route>
            </Route>
        </Route>
    );
}
